"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.regexp.search");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _uploadInvoiceDlg = _interopRequireDefault(require("./components/uploadInvoiceDlg"));
var _bankSlipConfirmDialog = _interopRequireDefault(require("./components/bankSlipConfirmDialog"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _importBillUpload = require("@/api/importBillUpload/importBillUpload");
var _index = _interopRequireDefault(require("@/components/Transfer/index.vue"));
var _indexHotOpt = _interopRequireDefault(require("./components/indexHotOpt"));
var _index2 = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _indexAmountButton = _interopRequireDefault(require("./components/indexAmountButton.vue"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "importBillUpload",
  components: {
    Transfer: _index.default,
    uploadInvoiceDlg: _uploadInvoiceDlg.default,
    bankSlipConfirmDialog: _bankSlipConfirmDialog.default,
    Pagination: _Pagination.default,
    filterColumn: _index2.default,
    customRenderer: _indexHotOpt.default,
    buttonRenderer: _indexAmountButton.default
  },
  data: function data() {
    return {
      loading: null,
      amountStr: "",
      idBlNos: "",
      doBtnClickDOF: {},
      tableData: [],
      // 表格数据
      targetDataOne: [],
      sourceData: [],
      tableKey: 0,
      transferDialogVisible: false,
      formDialog: {},
      paymentNo: "",
      total: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      language: 'zh',
      // 或 'en'，根据你的应用的语言设定
      filterForm: {
        blNoAndContainerNo: '',
        pod: ''
      },
      pod: '',
      hotSettings: {
        dragCheck: true,
        height: 'calc(100vh - 375px)',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        autoColumnSize: true,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      windowHeight: window.innerHeight,
      uploadInvoiceDlgVisible: false,
      rules: {
        blNoAndContainerNo: [{
          required: true,
          message: this.$t('importBillUpload.blNoNotNull'),
          trigger: 'blur'
        }],
        pod: [{
          required: true,
          message: this.$t('importBillUpload.podNotNull'),
          trigger: 'blur'
        }]
      },
      podList: ["CNSHK", 'CNNSA', 'CNYPG']
    };
  },
  created: function created() {
    this.initData();
  },
  methods: {
    //重置
    handleResetFn: function handleResetFn() {
      this.filterForm.blNoAndContainerNo = '';
      this.filterForm.pod = '';
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTable.resizeTo();
    },
    handleSubimtSort: function handleSubimtSort(data) {
      this.transferDialogVisible = false;
      this.sourceData = data;
      this.tableKey += 1;
      this.handleSearch();
    },
    handleUploadInvoiceDlg: function handleUploadInvoiceDlg() {
      this.uploadInvoiceDlgVisible = false;
      this.handleSearch();
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    handleSortOpen: function handleSortOpen() {
      this.transferDialogVisible = true;
    },
    initData: function initData() {
      var _this = this;
      this.sourceData = [{
        data: 'amount',
        title: this.$t('importBillUploadTable.amount')
      }, {
        data: 'chargineStatus',
        title: this.$t('importBillUploadTable.paymentStatus'),
        tableListCS: true
      }, {
        data: 'invoiceState',
        title: this.$t('importBillUploadTable.applyInvoice'),
        tableListIS: true
      }, {
        data: 'bkNo',
        title: this.$t('importBillUploadTable.orderNo')
      }, {
        data: 'blNo',
        title: this.$t('importBillUploadTable.blNo')
      }, {
        data: 'vesselCode',
        title: this.$t('importBillUploadTable.vesselCode')
      }, {
        data: 'voyageNo',
        title: this.$t('importBillUploadTable.voyageNo')
      }, {
        data: 'voyageLeg',
        title: this.$t('importBillUploadTable.voyageLeg')
      }, {
        data: 'pol',
        title: this.$t('importBillUploadTable.pol')
      }, {
        data: 'etd',
        title: this.$t('importBillUploadTable.etd')
      }, {
        data: 'pod',
        title: this.$t('importBillUploadTable.pod')
      }, {
        data: 'eta',
        title: this.$t('importBillUploadTable.eta')
      }, {
        data: 'del',
        title: this.$t('importBillUploadTable.del')
      }, {
        data: 'bankSlipAuditRemark',
        title: this.$t('importBillUploadTable.bankSlipAuditRemark')
      }, {
        data: 'invoicingApplicationAuditRemark',
        title: this.$t('importBillUploadTable.auditRemark')
      }];
      this.targetDataOne = [{
        data: 'feesStateListInId',
        title: 'feesStateListInId'
      }, {
        data: 'paymentWay',
        title: 'paymentWay'
      }, {
        data: 'attachment',
        title: 'attachment',
        isShow: true
      }, {
        data: 'amount2',
        title: 'amount2'
      }, {
        data: 'companyName',
        title: 'companyName'
      }, {
        data: 'bankSlipDOF',
        title: 'bankSlipDOF'
      }, {
        data: 'invoiceDOF',
        title: 'invoiceDOF'
      }, {
        data: 'amountDOF',
        title: 'amountDOF'
      }];
      this.tableKey += 1;
      this.$refs.transfer && this.$refs.transfer.initData(this.sourceData, this.targetDataOne);
      this.$nextTick(function () {
        _this.handleSearch();
      });
    },
    handleSearch: function handleSearch() {
      var _this2 = this;
      this.$refs['filterForm'].validate(function (valid) {
        if (valid) {
          _this2.loading = (0, _utils.load)();
          (0, _importBillUpload.search)(_this2.listQuery, _this2.filterForm.blNoAndContainerNo, _this2.filterForm.pod).then(function (res) {
            if (res.success) {
              _this2.tableData = res.data.records;
              _this2.total = res.data.totalRecord;
            }
          }).catch(function () {}).finally(function () {
            _this2.loading.close();
          });
        }
      });
    },
    handleBankSlipUploadApplyInvoice: function handleBankSlipUploadApplyInvoice() {
      var _this3 = this;
      var hotTableSelections = this.$refs.hotTable.getSelections();
      if (hotTableSelections.length === 0) {
        this.$message.error(this.$t('importBillUpload.pleaseCheckData'));
        return;
      }
      if (hotTableSelections.length > 10) {
        this.$message.error(this.$t('importBillUpload.limit10Data'));
        return;
      }
      //       1、接受状态提示：
      //       该单号已申请开票并接受，无需再上传水单。
      //       我司机器人后台会自动获取付款信息并进行销账，请直接关注电放情况即可。
      //       2、申请状态提示：
      //      申请中，请勿重复提交！
      if (hotTableSelections.some(function (item) {
        return item.invoiceState == '00';
      })) {
        this.$message.error(this.$t('importBillUpload.applicationInProgress'));
        return;
      }
      if (hotTableSelections.some(function (item) {
        return item.invoiceState == '01';
      })) {
        this.$message.error(this.$t('importBillUpload.invoiceAndPaymentAutoProcessing'));
        return;
      }
      if (hotTableSelections.some(function (item) {
        return item.invoiceCount > 0;
      })) {
        this.$message.error(this.$t('importBillUpload.noSecondOpr'));
        return;
      }
      var feesStateListInIds = hotTableSelections.map(function (select) {
        return select.feesStateListInId + "/" + select.blNo;
      }).join(',');
      ;
      var amount = hotTableSelections.map(function (select) {
        return select.amount2;
      }).join(',');
      var ids = hotTableSelections.map(function (select) {
        return select.feesStateListInId;
      });
      var amountDOFs = hotTableSelections.map(function (select) {
        return select.amountDOF;
      }).join(',');
      this.doBtnClickDOF = {
        feesStateListIds: ids,
        amountStr: amount,
        amountDOFStr: amountDOFs
      };
      this.amountStr = amount;
      this.idBlNos = feesStateListInIds;
      this.loading = (0, _utils.load)();
      (0, _importBillUpload.openDialog)(amount, feesStateListInIds).then(function (res) {
        _this3.loading.close();
        if (res.success) {
          _this3.formDialog = res.data;
          _this3.pod = hotTableSelections[0].pod;
          if (res.data.paymentNo != null && res.data.paymentNo != "") {
            _this3.paymentNo = res.data.paymentNo;
          } else {
            _this3.paymentNo = hotTableSelections[0].companyName;
          }
          _this3.uploadInvoiceDlgVisible = true;
        }
      }).catch(function () {
        _this3.loading.close();
      });
    },
    invoiceStateRenderer: function invoiceStateRenderer(instance, td, row, col, prop, value, cellProperties) {
      if (value == "00") {
        td.innerHTML = '申请';
      } else if (value == "01") {
        td.innerHTML = '接受';
      } else if (value == "02") {
        td.innerHTML = '拒绝';
      } else if (value == "03") {
        td.innerHTML = '有变更';
      } else {
        td.innerHTML = value;
      }
      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    paymentStateValRenderer: function paymentStateValRenderer(instance, td, row, col, prop, value, cellProperties) {
      if (value == "0") {
        td.innerHTML = '未付款';
      } else if (value == "1") {
        td.innerHTML = '已付款';
      } else if (value == "2") {
        td.innerHTML = '已到账';
      } else {
        td.innerHTML = value;
      }
      // 设置单元格样式，使内容居中
      td.style.textAlign = 'center';
      td.style.verticalAlign = 'middle';
      return td;
    },
    querySysAccountPort: function querySysAccountPort() {
      var _this4 = this;
      this.loading = (0, _utils.load)();
      (0, _importBillUpload.querySysAccountPort)().then(function (res) {
        if (res.success) {
          var portCodes = res.data;
          _this4.podList = _this4.podList.filter(function (item) {
            return portCodes.includes(item);
          });
        }
      }).catch(function (error) {
        console.log(error);
      }).finally(function () {
        _this4.loading.close();
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;
    this.querySysAccountPort();
    this.$nextTick(function () {
      _this5.resizeHotTable();
    });
  }
};